import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  ERROR_URL,
  LAYOUT_ERROR_URL,
  LAYOUT_URL,
  PRE_SIMULATOR_URL,
  SUMMARY_SECOND_HOLDER,
} from '../../utils/constants';

@Injectable()
export class NavigationService {
  constructor(private router: Router) {}

  public redirectToError(error = null) {
    this.router.navigate([ERROR_URL], {
      queryParams: {
        error: JSON.stringify(error),
      },
    });
  }

  public redirectToLayoutError(error = null) {
    this.router.navigate([LAYOUT_ERROR_URL], {
      queryParams: {
        error: JSON.stringify(error),
      },
    });
  }

  public redirectToLayout() {
    this.router.navigate([LAYOUT_URL]);
  }

  public redirectToPreSimulator() {
    this.router.navigate([PRE_SIMULATOR_URL]);
  }

  public redirectSummarySecondHolder() {
    this.router.navigate([SUMMARY_SECOND_HOLDER]);
  }

  public getCurrentURL() {
    return this.router.url;
  }
}
